export default state => {
  const { received, sent, aSyncCall } = state.messages;
  return {
    receivedMessages: received,
    sentMessages: sent,
    messageAsyncCall: aSyncCall
  };
};

export const selectNewMessages = state => {
  const { notification } = state.messages;
  return {
    newMessages: notification
  };
};

export const selectBroadcasts = state => {
  const { broadcasts } = state.messages;
  return {
    broadcastedMessages: broadcasts
  };
};

export const selectReceivedMessages = state => {
  const { received } = state.messages;
  return {
    receivedMessages: received
  };
};

export const selectSentMessages = state => {
  const { sent } = state.messages;
  return {
    sentMessages: sent
  };
};

export const selectNewBroadcasts = state => {
  const { newBroadcasts } = state.messages;
  return {
    newBroadcasts
  };
};

export const selectEmails = state => {
  const { emails } = state.messages;
  return {
    emails
  };
};

export const selectSms = state => {
  const { smsMessages } = state.messages;
  return {
    smsMessages
  };
};



// WEBPACK FOOTER //
// ./src/selectors/messagesSelector.js